import { getFormattingLanguage } from '../utils/getFormattingLanguage';
export function createDeliveryOptionsServiceGetter(locale, httpClient, controllerConfig, errorHandler) {
  let serviceInstance = null;
  return async () => {
    /* istanbul ignore else */
    if (!serviceInstance) {
      const {
        DeliveryOptionsService
      } = await import('@wix/delivery-section-checkout/services');
      serviceInstance = new DeliveryOptionsService({
        translationLang: locale,
        locale: getFormattingLanguage(controllerConfig),
        httpClient,
        timezone: controllerConfig.wixCodeApi.site.timezone,
        experiments: controllerConfig.essentials.experiments,
        errorHandler
      });
    }
    return serviceInstance;
  };
}
//# sourceMappingURL=deliveryOptionsGetter.js.map